import {
  Grid,
  Modal,
  Switch,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import React, { useCallback } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button,
  Box,
  Link,
} from "@mui/material";
import "./Currencies.scss";

import { styled } from "@mui/material/styles";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import UGTable from "../../../../../../Supporting files/UGTable/UGTable";
// import SlidingPanel from "react-sliding-side-panel";
// import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
// import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
// import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import AddCurrency from "./AddCurrency";

const Currencies = () => {
  const [addcurrency, setAddCurrency] = React.useState(false);
  const [exchangeRate, setExchangeRate] = React.useState(true);
  const [exchangeRateConfrm, setExchangeRateConfrm] = React.useState(false);

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "currname",
      headerName: "Currency Name",
      width: 200,
      flex: 1,
      check_status: true,
    },
    {
      field: "currcode",
      headerName: "Currency Code",
      width: 150,
      flex: 1,
      check_status: true,
    },
    {
      field: "currsymbol",
      headerName: "Currency Symbol",
      width: 150,
      flex: 1,
      check_status: true,
    },
    {
      field: "fraction",
      headerName: "Fraction",
      width: 100,
      flex: 1,
      check_status: true,
    },
    {
      field: "fractionunit",
      headerName: "Fraction Unit",
      width: 150,
      flex: 1,
      check_status: true,
    },
    {
      field: "decimalplace",
      headerName: "Decimal Places",
      width: 200,
      flex: 1,
      check_status: true,
    },
    {
      field: "format",
      headerName: "Format",
      width: 150,
      flex: 1,
      check_status: true,
    },
    {
      field: "exchangerate",
      headerName: "Exchange Rate (In INR)",
      width: 200,
      flex: 1,
      check_status: true,
    },
    {
      field: "ondate",
      headerName: "As on Date",
      width: 100,
      flex: 1,
      check_status: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      flex: 1,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <>
            <Link
              underline="none"
              className="actiondelete"
              onClick={() => {
                //navigate("/ContactDetail");
              }}
            ></Link>
            <Link
              underline="none"
              className="actionedit"
              onClick={() => {
                setAddCurrency(true);
              }}
            ></Link>
          </>
        );
      },
    },
  ]);
  const rows = [
    {
      id: 0,
      currname: "UAE Dirham",
      currcode: "AED",
      currsymbol: "$",
      fraction: "fils",
      fractionunit: 100,
      decimalplace: 3,
      format: "000.00",
      exchangerate: 22,
      ondate: "23-11-2021",
      actions: "",
    },
    {
      id: 1,
      currname: "Australian Dollar",
      currcode: "AUD",
      currsymbol: "$",
      fraction: "cents",
      fractionunit: 100,
      decimalplace: 3,
      format: "000.00",
      exchangerate: 22,
      ondate: "23-11-2021",
      actions: "",
    },
    {
      id: 2,
      currname: "Canadian Dollar",
      currcode: "CAD",
      currsymbol: "$",
      fraction: "cents",
      fractionunit: 100,
      decimalplace: 3,
      format: "000.00",
      exchangerate: 22,
      ondate: "23-11-2021",
      actions: "",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
    if (attrName === setExchangeRate && value === false) {
      setExchangeRateConfrm(true);
    }
  };
  return (
    <Grid container spacing={2} className="currunciesWrapper">
      <Grid item xs={4}>
        <h3 className="mb-0">Currencies</h3>
      </Grid>

      <Grid item xs={8} className="text-right">
        <div className="buttons">
          <h6 className="mb-0">Base Currency: ₹ INR</h6>
          <Link
            underline="none"
            className="greenBtn addfile"
            onClick={() => {
              setAddCurrency(true);
            }}
          >
            Add Currency
          </Link>
          <Switch
            defaultChecked
            checked={exchangeRate}
            onChange={() => {
              updateMasterState(setExchangeRate, !exchangeRate);
            }}
          />
          <p>Exchange Rate Feeds</p>
          {/*<Link
              className="switchDetails"
              onClick={() => {
                setCurrencyFeed(true);
              }}>
              <input type="checkbox" className="switch" />
              <p>Exchange Rate Feeds</p>
            </Link> */}
        </div>
        <Modal open={exchangeRateConfrm} className="modalWrapper">
          <Box className="modalInner currencypopup">
            <Grid container spacing={3}>
              <Grid xs={12}>
                <p className="currencyData">
                  Kindly manually enter the exchange rates for each curerency,
                  once you have disabled this feature.
                </p>
              </Grid>
              <Grid xs={6} className="ctaBtn" style={{ textAlign: "right" }}>
                <Button
                  variant="contained"
                  className="submitBtn mr-2"
                  onClick={() => {
                    setExchangeRateConfrm(false);
                  }}
                >
                  Disable
                </Button>
              </Grid>
              <Grid xs={6} className="ctaBtn" style={{ textAlign: "left" }}>
                <Button
                  className="borderBtn ml-2"
                  onClick={() => {
                    setExchangeRateConfrm(false);
                    setExchangeRate(true);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </Grid>
      <Grid item xs={12}>
        <AddCurrency
          add_cuurency_status={exchangeRate}
          attrName={setAddCurrency}
          open_status={addcurrency}
          value_update={updateMasterState}
        />
        <div style={{ height: 400 }}>
          <UGTable
            header_data={columns}
            data={rows}
            value_update={updateMasterState}
            attrName={"UGTable"}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default Currencies;
